module.exports = __webpack_public_path__ + "static/media/peernote-large.96b081cb.png";